import { render, staticRenderFns } from "./AamsGiftBaseCategory.vue?vue&type=template&id=586182da&scoped=true&"
import script from "./AamsGiftBaseCategory.vue?vue&type=script&lang=js&"
export * from "./AamsGiftBaseCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586182da",
  null
  
)

export default component.exports